// extracted by mini-css-extract-plugin
export default {"column":"StatusColumn_column__n5Z+b","cardsContainer":"StatusColumn_cardsContainer__QT7iY"};